<template lang="pug">
  .contenedor-datos
    .title
      span.little Mis datos editables
      span.icon.close(@click="$emit('close')")
        i.fa.fa-close

    section
      .title
        | Datos personales
      loading(v-if="isLoading")
      .body(v-else)
        .columns
          .column
            p Apellido paterno
            input.input(type="text", v-model="empleado.apellidoPaterno")
          .column
            p Apellido materno
            input.input(type="text", v-model="empleado.apellidoMaterno")
          .column
            p Nombres
            input.input(type="text", v-model="empleado.nombres")
          .column
            p Genero
            .opciones
              .opcion(@click="empleado.genero = 'F'", :class="{'active': empleado.genero === 'F'}")
                span F
              .opcion(@click="empleado.genero = 'M'", :class="{'active': empleado.genero === 'M'}")
                span M
        .columns
          .column
            p Fecha de nacimiento
            input.input(type="date", v-model="empleado.fechaNacimiento", pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}")
          .column
            p Teléfono personal
            input.input(type="text", v-model="empleado.telefonoPersonal")
          .column
            p Email personal
            input.input(type="text", v-model="empleado.emailPersonal")
          .column
            p Grado académico
            input.input(type="text", v-model="empleado.gradoAcademico")

        .columns
          .column
            p DNI
            input.input(type="number", v-model="empleado.dni")
          .column
            p Dirección actual de residencia
            input.input(type="text", v-model="empleado.direccion")

    section
      .title
        | Datos salud y emergencia
      loading(v-if="isLoading")
      .body(v-else)
        .flex
          .control
            p Tipo de Sangre
            input.input(
              type="text",
              v-model="empleado.tipoSangre"
            )
          .control.flex-1
            p Nombre contacto de emergencia
            input.input(
              type="text",
              v-model="empleado.nombreEmergencia"
            )
          .control
            p Telefono contacto de emergencia
            input.input(
              type="text",
              v-model="empleado.telefonoEmergencia"
            )

        .control
          p Alergias a algun medicamento
          textarea.textarea(v-model="empleado.alergiasMedicamento")

    section.section-familia
      .title
        | Datos de familia
      loading(v-if="isLoading")
      .body(v-else)
        transition-group.flex.contenedor-transition.contenedor-familia(name="fade-smooth")
          .control(key="tiene-conyugue")
            p ¿Tiene conyugue?
            .opciones
              .opcion(
                @click="empleado.estaCasado = true"
                :class="{'active': empleado.estaCasado}"
              )
                span Si
              .opcion(
                @click="empleado.estaCasado = false"
                :class="{'active': !empleado.estaCasado}"
              )
                span No
          .flex.flex-1.contenedor-conyugue(v-if="empleado.estaCasado", key="datos-conyugue")
            .flex.flex-1
              .control.flex-1
                p Nombre de conyugue
                input.input(
                  type="text",
                  v-model="empleado.nombreConyugue"
                )
              .control
                p DNI/CE conyugue
                input.input(
                  type="text",
                  v-model="empleado.dniConyugue"
                )
            .flex
              .control.flex-1
                p Fecha de nacimiento conyugue
                input.input(
                  type="date",
                  v-model="empleado.fechaNacimientoConyugue",
                  pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                )

        transition-group.flex.contenedor-transition.contenedor-familia(name="fade-smooth")
          .control(key="tiene-hijos")
            p ¿Tiene hijos?
            .opciones
              .opcion(
                @click="empleado.tieneHijos = true"
                :class="{'active': empleado.tieneHijos}"
              )
                span Si
              .opcion(
                @click="empleado.tieneHijos = false"
                :class="{'active': !empleado.tieneHijos}"
              )
                span No
          transition-group.flex.flex-1.contenedor-transition.contenedor-hijos(
            name="fade-smooth"
            v-if="empleado.tieneHijos"
            key="contenedor-hijos"
          )
            div.flex-1.contenedor-hijo(
              v-for="(o, index) in hijos"
              :key="'hijos_'+index"
            )
              .flex.contenedor-hijo-break-1
                .flex.flex-1
                  .control.flex-1
                    p Nombre hijo
                    input.input(
                      type="text",
                      v-model="o.nombre"
                    )
                  .control
                    p DNI/CE hijo
                    input.input(
                      type="text",
                      v-model="o.dni"
                    )
                .flex
                  .control.flex-1
                    p Fecha de nacimiento hijo
                    input.input(
                      type="date",
                      v-model="o.fechaNacimiento",
                      pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                    )
                  .flex.contenedor-genero
                    .control
                      p Genero
                      .opciones
                        .opcion(
                          @click="o.genero = 'F'"
                          :class="{'active': o.genero === 'F'}"
                        )
                          span F
                        .opcion(
                          @click="o.genero = 'M'"
                          :class="{'active': o.genero === 'M'}"
                        )
                          span M
                    .button.button-quitar-hijo(
                      @click="quitarHijo(index)"
                    )
                      span.icon
                        i.fa.fa-minus
            .contenedor-boton-agregar-hijo(
              v-if="empleado.tieneHijos"
              name="Agregar hijo"
              @click="agregarHijoVacio"
              key="agregar-hijo"
            )
              button.button
                span.icon.is-small
                  i.fa.fa-plus
                span Agregar


    section
      .title
        | Datos del trabajo
      loading(v-if="isLoading")
      .body(v-else)
        .flex
          .control
            p Anexo
            input.input(
              type="number",
              v-model="empleado.anexo"
            )
          .control
            p Celular de trabajo
            input.input(
              type="number",
              v-model="empleado.celularTrabajo"
            )

    section.contenedor-guardar
      button.button.is-primary(
        @click="guardar"
        :class="{'is-loading': isSaving}"
      )
        span.icon.is-small
          i.fa.fa-save.fa-fw.fa-lg
        span Guardar

</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
export default {
  name: 'datos_personales_editable_component',
  data () {
    return {
      empleado: {
        genero     : '',
        estaCasado : false,
        tieneHijos : false
      },
      hijos: [
        {
          nombre          : '',
          dni             : '',
          fechaNacimiento : '',
          genero          : ''
        }
      ],
      isSaving: false,
      isLoading: false
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
      }
      apiGet(vm, '/personal/empleado', obj, function (data) {
        vm.hijos         = data.hijos
        if (vm.hijos.length > 0) {
          data.empleadoPersonal.tieneHijos = true
        } else {
          data.empleadoPersonal.tieneHijos = false
          vm.hijos = [
            {
              nombre          : '',
              dni             : '',
              fechaNacimiento : '',
              genero          : ''
            }
          ]
        }

        if (data.empleadoPersonal && data.empleadoPersonal.codigo) {
          if (data.empleadoPersonal.dniConyugue) {
            data.empleadoPersonal.estaCasado = true
          } else {
            data.empleadoPersonal.estaCasado = false
          }
          vm.empleado = data.empleadoPersonal
        } else {
          vm.empleado = {
            genero     : '',
            estaCasado : false,
            tieneHijos : false
          }
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    agregarHijoVacio () {
      this.hijos.push({
        nombre          : '',
        dni             : '',
        fechaNacimiento : '',
        genero          : ''
      })
    },
    quitarHijo (index) {
      this.hijos.splice(index, 1)
    },
    guardar () {
      var vm = this
      vm.isSaving = true

      // Algunas validaciones
      if (!vm.empleado.estaCasado) {
        vm.empleado.nombreConyugue = null
        vm.empleado.dniConyugue = null
        vm.empleado.fechaNacimientoConyugue = null
      } else {
        if (!vm.empleado.nombreConyugue) {
          notify(vm, 'error', 'Ingrese el nombre de su conyugue')
          vm.isSaving = false
          return
        }
        if (!vm.empleado.dniConyugue) {
          notify(vm, 'error', 'Ingrese el dni de su conyugue')
          vm.isSaving = false
          return
        }
        if (!vm.empleado.fechaNacimientoConyugue) {
          notify(vm, 'error', 'Ingrese la fecha de nacimiento de su conyugue')
          vm.isSaving = false
          return
        }
      }

      if (!vm.empleado.tieneHijos) {
        vm.hijos = []
        vm.agregarHijoVacio()
      }

      var obj = {
        empleado: vm.empleado,
        hijos: vm.hijos
      }

      apiPost(vm, '/personal/empleado', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-transition
    >*
      transition: all 0.5s;

  .contenedor-datos
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  section
    .control
      margin 5px
    .title
      text-align left
      border-bottom 2px solid #565cde
      padding-bottom 10px
      font-size 20px !important

  .flex
    display flex
    flex-wrap wrap   // Agrega flex-wrap para permitir el colapso en múltiples filas
  .flex-1
    flex 1

  .opciones
    display flex
    .opcion
      cursor pointer
      width 50px
      margin 5px
      text-align center
      border 1px solid #565cde
      flex 1
      &.active
        background-color #565cde
        color white

  section
    margin-bottom 10px

  .contenedor-boton-agregar-hijo
    display flex
    justify-content center
    margin-top 10px

  .contenedor-hijos
    flex-direction column

  .button-quitar-hijo
    margin-top auto
    margin-bottom 10px
    background-color red
    i
      color: #fff
  // .section-familia


  @media (max-width: 1006px)
    .section-familia
      .contenedor-familia
        flex-direction column
      .contenedor-hijo
        &:not(:last-child)
          border-bottom: 1px solid #0a0a0a1a;
          margin-bottom: 10px;
  // datos salud emergecia
  @media (max-width: 750px)
    .body
      .flex
        flex-direction column

  @media (max-width: 700px)
    .section-familia
      .contenedor-hijo-break-1
        flex-direction column

  // Media query para pantallas de 640px o menos
  @media (max-width: 640px)
    .flex-1
      width 100%   // Establece el ancho al 100% para que ocupe toda la fila

  @media (max-width: 608px)
    .section-familia
      .contenedor-conyugue
        flex-direction column

  @media (max-width: 414px)
    .section-familia
      .contenedor-familia
        .flex
          flex-direction column
          &.contenedor-genero
            flex-direction row

</style>




// WEBPACK FOOTER //
// Component_Datos_Personales_Editable.vue?604dbb8e